/*
  Cartes produit (collections, accueil, recherche, recommandations) : le titre est coupé à la
  première virgule pour l'affichage. Le nom passe en gras, le reste en petit dessous. Le titre du
  produit n'est pas modifié, la virgule reste lue par les lecteurs d'écran. Sans virgule, rien ne change.
  Le snippet natif card-product n'est pas touché : la découpe se fait ici, y compris pour les cartes
  chargées plus tard (filtres, pagination, recommandations).
*/
(function () {
  var SEL = '.card__heading';
  function echapper(t) {
    return t.replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function decouper(racine) {
    (racine || document).querySelectorAll(SEL).forEach(function (h) {
      var cible = h.querySelector('a') || h;
      if (cible.getAttribute('data-ol-titre')) return;
      if (cible.children.length) return;           // contenu inattendu : on n'y touche pas
      var texte = (cible.textContent || '').replace(/\s+/g, ' ').trim();
      var i = texte.indexOf(',');
      if (!texte) return;
      cible.setAttribute('data-ol-titre', '1');
      if (i < 1) { cible.innerHTML = '<span class="ol-carte__nom">' + echapper(texte) + '</span>'; return; }
      var nom = texte.slice(0, i).trim(), reste = texte.slice(i + 1).trim();
      cible.innerHTML = '<span class="ol-carte__nom">' + echapper(nom) + '</span>' +
        (reste ? '<span class="visually-hidden">, </span><span class="ol-carte__reste">' + echapper(reste) + '</span>' : '');
    });
  }
  decouper();
  document.addEventListener('DOMContentLoaded', function () { decouper(); });
  document.addEventListener('shopify:section:load', function (e) { decouper(e.target); });
  if ('MutationObserver' in window) {
    var attente = null;
    new MutationObserver(function () {
      if (attente) return;
      attente = setTimeout(function () { attente = null; decouper(); }, 60);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
